import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAudio, useAuth, useConfig } from '@chainlit/react-client';

import AudioPresence from '@/components/AudioPresence';
import ButtonLink from '@/components/ButtonLink';
import { useSidebar } from '@/components/ui/sidebar';

import ApiKeys from './ApiKeys';
import ChatProfiles from './ChatProfiles';
import NewChatButton from './NewChat';
import ReadmeButton from './Readme';
import SidebarTrigger from './SidebarTrigger';
import UserNav from './UserNav';

import IncidentUpdatesButton from './InicidentButton';
import getRouterBasename from '@/lib/router';
import CbreLogoWhite from '@/assets/CBRE_white.svg'; // <-- bundle-safe import
import { NotificationsDropdown } from './NotificationsDropdown';

const Header = memo(() => {
  const { audioConnection } = useAudio();
  const navigate = useNavigate();
  const { data } = useAuth();
  const { config } = useConfig();
  const { open, openMobile, isMobile } = useSidebar();
  const base = getRouterBasename(); // if basename is set (e.g. /portal)
  const { user } = useAuth();

  const sidebarOpen = isMobile ? openMobile : open;
  const historyEnabled = data?.requireLogin && config?.dataPersistence;
  const links = config?.ui?.header_links || [];
  const isAskAWatch = location.pathname === '/askawatch';
  const incident_comms_admin = (user?.metadata as any)?.incident_comms_admin || false;


  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 border-b border-white/10 bg-[#003F2D]/95 backdrop-blur supports-[backdrop-filter]:bg-[#003F2D]/80">
      <div className="flex h-full items-center justify-between px-4">
        {/* Left section */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            {/* Use imported asset (works in build) */}
            <img
              src={CbreLogoWhite}
              alt="CBRE"
              className="h-8 w-auto object-contain"
              draggable="false"
            />
            {/* If you insist on using public folder path, fallback: */}
            {/* <img src={`${base}/images/CBRE_white.svg`} alt="CBRE" /> */}
            <div className="h-6 w-px bg-white/20" />
            <div className="flex flex-col">
              <h1 className="text-xl text-white tracking-tight bg-gradient-to-r from-white to-white/80 bg-clip-text">
          MS AIOps Portal
              </h1>
              <p className="text-sm text-white/60">
          {location.pathname === '/askawatch' ? 'AskAWatch' : 
           location.pathname === '/incidentcommunication' ? 'Incident Communication' :
           location.pathname === '/changevalidation' ? 'Change Validation' :
           location.pathname === '/awatch' ? 'AWatch' :
           location.pathname.slice(1).charAt(0).toUpperCase() + location.pathname.slice(2)}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 ml-2">
            <SidebarTrigger />
            <ChatProfiles navigate={navigate} />
          </div>
        </div>

        {/* Center - Audio presence */}
        {audioConnection === 'on' && (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <AudioPresence
              type="server"
              height={28}
              width={56}
              barCount={4}
              barSpacing={2}
            />
          </div>
        )}

        {/* Right section */}
        <div className="flex items-center gap-2">
          {/* {isAskAWatch &&
            (historyEnabled
              ? !sidebarOpen && <NewChatButton navigate={navigate} />
              : <NewChatButton navigate={navigate} />)} */}
          {incident_comms_admin && <NotificationsDropdown />}
          {/* <NotificationsDropdown /> */}
          <UserNav />
        </div>
      </div>
    </header>
  );
});

export { Header };

{/* <ApiKeys />
          {links.map((link, index) => (
            <ButtonLink
              key={`${link.name}-${link.url}-${index}`}
              name={link.name}
              iconUrl={link.icon_url}
              url={link.url}
            />
          ))}
          <UserNav /> */}
